import React, { useContext, useRef } from 'react';
import LineItem from './LineItem';
import Client from 'shopify-buy';
import { CheckoutsContext, CartContext } from "./products/productsContext"

const client = Client.buildClient({
  domain: 'blue-lion-apparel-llc.myshopify.com',
  storefrontAccessToken: '34acd07c5cbc899e721d17d94b11b2c6'
});


const CartDetails = (_props) => {

  const [showCart, setShowCart] = useContext(CartContext)
  const [checkout, setCheckout] = useContext(CheckoutsContext)
  const container = useRef(null);

  const openCheckout = () => {
    window.open(checkout.webUrl);
  }

  const updateQuantityInCart = (lineItemId, quantity) => {
    const checkoutId = checkout.id
    const lineItemsToUpdate = [{ id: lineItemId, quantity: parseInt(quantity, 10) }]
    client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(res => {
      setCheckout(res)
      localStorage.setItem("cart", JSON.stringify(res))
    });
  }

  const removeLineItemInCart = (lineItemId) => {
    const checkoutId = checkout.id
    client.checkout.removeLineItems(checkoutId, [lineItemId]).then(res => {
      setCheckout(res)
      localStorage.setItem("cart", JSON.stringify(res))
    });
  }

  // handleAwayClick(container, (event) => {
  //   container.current.style.top = (event.clientY - container.current.clientHeight/2) + "px";
  //   document.getElementById('Cart__line-items').style.maxHeight = parent.window.innerHeight-600 + "px";
  // });

  const handleCloseCart = () => {
    setShowCart(false)
  }


  const line_items = checkout.lineItems.map((line_item) => {
    return (
      <LineItem
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
        key={line_item.id.toString()}
        line_item={line_item}
      />
    );
  });

  return (
    <div ref={container} className={showCart ? "Cart Cart--open" : "Cart Cart__close display-none"}>
      <header className="Cart__header">
        <h2>Your cart</h2>
        <button
          onClick={handleCloseCart}
          className="Cart__close">
          ×
        </button>
      </header>
      <ul id="Cart__line-items" className="Cart__line-items">
        {line_items}
      </ul>
      <footer className="Cart__footer">
        <div className="Cart-info clearfix">
          <div className="Cart-info__total Cart-info__small">Subtotal</div>
          <div className="Cart-info__pricing">
            <span className="pricing">$ {checkout.subtotalPrice.amount}</span>
          </div>
        </div>
        <div className="Cart-info clearfix">
          <div className="Cart-info__total Cart-info__small">Taxes</div>
          <div className="Cart-info__pricing">
            <span className="pricing">$ {checkout.totalTax.amount}</span>
          </div>
        </div>
        <div className="Cart-info clearfix">
          <div className="Cart-info__total Cart-info__small">Total</div>
          <div className="Cart-info__pricing">
            <span className="pricing">$ {checkout.totalPrice.amount}</span>
          </div>
        </div>
        <button className="Cart__checkout button" onClick={openCheckout}>Checkout</button>
      </footer>
    </div>
  )
}


export default CartDetails;



// WEBPACK FOOTER //
// ./src/components/CartDetails.js